import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MediaHelperService} from '../../core/media-helper.service';
import {SearchObject} from '../../core/definitions/search-object';

@Component({
  selector: 'app-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss']
})
export class ThumbnailComponent implements OnInit, OnDestroy {
  public imgClass = '';

  @Input() item: SearchObject;
  @Input() viewMode;
  @Input() imageIdField;
  @Input() stylingClass: string;

  constructor(private readonly mediaHelper: MediaHelperService) {

  }

  ngOnInit() {
    if (this.item) {
      this.mediaHelper.setThumbnailUrl(this.item, this.imageIdField).then(() => this.showImageOrPlaceholder());
    }
  }

  ngOnDestroy() {
    // This will stop upload status timeout started in mediaHelper
    this.mediaHelper.cancelUploadWait(this.item);
  }

  private showImageOrPlaceholder() {
    this.imgClass = this.stylingClass ? this.stylingClass + ' ' : '';
    if (this.item.$$thumbnailUrl) {
      if (this.viewMode && this.viewMode === 'thumbnail') {
        this.imgClass += 'searchThumbnailBig';
      } else {
        this.imgClass += 'searchThumbnail';
      }
    } else {
      if (this.viewMode && this.viewMode === 'thumbnail') {
        this.imgClass += 'imgPlaceholderBig';
      } else {
        this.imgClass += 'imgPlaceholder';
      }
    }
  }

}
